export enum CHANNEL {
  PRACTO = "Practo",
  COVID_CONNECT = "Covid-Connect",
  CORPORATE_CONNECT = "Corporate-Connect",
  SPHERE_INDIA_PSYCHOLOGY = "SPPS",
  SPHERE_INDIA_COVID = "SPCO",
  TALK_TO_DOCTOR = "TTD",
  SECOND_OPINION = "SECO",
  EMERGENCY = "EMCY",
  CORPORATE_CONNECT_INIT = "CC-Init",
  WALKIN = "Walkin",
  WALKINQR = "Walkin-Scan",
  OFFLINE = "Offline",
  ON_PAD = "ON-PAD",
  UHI_HPD = "UHI_HPD",
  UHI_DCM = "UHI_DCM",
  IVR = "IVR",
  STAFF = "Staff",
  DOCTOR = "Doctor",
  FOLLOW_UP = "FOLLOW-UP",
  ONLINE_APPOINTMENT = "Online-Appointment",
}

export enum APPOINTMENT_STATUS {
  CANCELLED = "CN",
  ABORTED = "AB",
  NO_SHOW = "NS",
  NO_SHOW_DOCTOR = "NSD",
  NO_SHOW_STAFF = "NSS",
  COMPLETED = "CM",
  RESCHEDULED = "RE",
  ONGOING = "OG",
  BOOKED = "BK",
  PARKED = "PA",
  PROVISIONAL_CANCELLED = "PC",
  COMPLETED_NO_PRESCRIPTION = "CMNP",
  DOCTOR_RESCHEDULED = "RED",
  DOCTOR_CANCELLED = "CND",
  STAFF_RESCHEDULED = "RES",
  STAFF_CANCELLED = "CNS",
  PAYMENT_NOT_RECEIVED = "PNR",
  INITIATED = "IN",
  RESERVED = "RV",
  CHECKED_IN = "CK",
  COMPLETED_IP = "CMIP",
}

export enum MODES_OF_APT {
  TELE = "tele",
  IN_CLINIC = "in_clinic",
}

export enum PAYMENT_STATUS {
  unbilled = "unbilled",
  success = "success",
  failed = "failed",
  created = "created",
  to_refund = "to_refund",
  refund_processed = "refund_processed",
  refunded = "refunded",
  cancelled = "cancelled",
}

export enum RECEIPT_PAYMENT_MODE {
  CASH = "CASH",
  UPI = "UPI",
  DEBIT_CARD = "DEBIT_CARD",
  GPAY = "GPAY",
  PAYTM = "PAYTM",
  CREDIT_CARD = "CREDIT_CARD",
  OTHER = "OTHER",
  EKA_POSTPAY = "EKA_POSTPAY",
  EKA_PREPAID = "EKA_PREPAID",
}
// make sure the order of this array is same as the enum above
export const RECEIPT_PAYMENT_MODES_ARRAY = [
  "CASH",
  "UPI",
  "DEBIT_CARD",
  "GPAY",
  "PAYTM",
  "CREDIT_CARD",
  "OTHER",
  "EKA_POSTPAY",
  "EKA_PREPAID",
] as RECEIPT_PAYMENT_MODE[];

export enum RECEIPT_DISCOUNT_TYPE {
  PERCENTAGE = "PERCENTAGE",
  AMOUNT = "AMOUNT",
}

export enum PAID_FILTER_VALUES {
  PAID = "paid",
  UNPAID = "unpaid",
}

export enum FOLLOWUP_DATE_VALUES {
  ADDED = "added",
  NOT_ADDED = "not_added",
}

export enum FOLLOWUP_STATUS_VALUES {
  ALL_FOLLOWUPS = "all_followups",
  AWAITING_RESPONSE = "awaiting_response",
  CONFIRMED_VISIT = "confirmed_visit",
  NOT_COMING = "not_coming",
}
